<!-- <div class="event-checkout-dialog">
    <div class="modal-body text-center" style="color: #FFFFFF;">
        <div *ngIf="!message" class="mt-70">
            <h2 class="mb-20">Do you want to create an account?</h2>
            <button mat-flat-button class="square-btn" (click)="continue(1)">Create an account</button>
            <button mat-flat-button class="square-btn bgc-grey ml-20" (click)="continue(0)">Continue as guest</button>
        </div>
        <div *ngIf="message" class="mt-70">
            <p>{{message}}</p>
            <button mat-flat-button class="square-btn" (click)="close()">OK</button>
        </div>
    </div>
</div> -->
<div mat-dialog-content class="app-signout-confirmation" id="app-signout-confirmation" [style.background-color]="settingsData?.event_bg_main_color +'!important'" [style.color]="settingsData?.event_font_main_color +'!important'">
    <div class="fs-16 pt-20 pb-10 text-center fw-500" *ngIf="!message && !messageStatus">Do you want to create an account?</div>    
    <div class="pb-20 text-center" mat-dialog-actions *ngIf="!message && !messageStatus">
        <button mat-flat-button (click)="continue('yes')" class="flat-primary-button primary-bg-button mt-10"
        [style.background-color]="settingsData?.event_button_bg_primary_color +'!important'" [style.color]="settingsData?.event_button_font_primary_color +'!important'">
            yes
        </button>
        <button mat-flat-button (click)="continue('no')" class="flat-primary-button secondary-bg-btn1 secondary-button-color mt-10"
        [style.background-color]="settingsData?.event_button_bg_secondary_color +'!important'" [style.color]="settingsData?.event_button_font_secondary_color +'!important'">
            No
        </button>
    </div>

    <div class="fs-16 pt-20 pb-10 text-center fw-500" *ngIf="message">{{message}}</div>    
    <div class="mt-10 pb-20 text-center" mat-dialog-actions *ngIf="message">
        <button mat-flat-button (click)="close()" class="flat-primary-button primary-bg-button"
        [style.background-color]="settingsData?.event_button_bg_primary_color +'!important'" [style.color]="settingsData?.event_button_font_primary_color +'!important'">
            <span *ngIf="!messageStatus">OK</span><span *ngIf="messageStatus">Sign in</span>
        </button>
    </div>
</div>